import React from 'react'
import MessageNote from './MessageNote'

const DefaultsErrorNote = ({noteMessage}: {noteMessage: string}) => {
  return (
    <MessageNote noteMessage={noteMessage} noteTitle="Unable to get default values"/>
  )
}

export default DefaultsErrorNote